import { parse, serialize } from 'cookie';
/**
 * Gets a cookie value. Works on both client and server.
 * @param name The name of the cookie.
 * @param context The server context, containing the `request` object for server-side operations.
 * @returns The cookie value or undefined.
 */
export function getCookie(name, context) {
    if (context?.request) {
        // Server-side: parse from the request's 'cookie' header.
        const cookieHeader = context.request.headers.get('cookie');
        if (!cookieHeader)
            return undefined;
        const cookies = parse(cookieHeader);
        return cookies[name];
    }
    if (typeof document !== 'undefined') {
        // Client-side: parse from document.cookie.
        const cookies = parse(document.cookie);
        return cookies[name];
    }
    return undefined;
}
/**
 * Sets a cookie. Works on both client and server.
 * On the server, it appends a 'Set-Cookie' header to the provided Headers object.
 * @param name The name of the cookie.
 * @param value The value of the cookie.
 * @param options Serialization options.
 * @param context The server context, containing the `responseHeaders` object for server-side operations.
 */
export function setCookie(name, value, options, context) {
    const cookieString = serialize(name, value, options);
    if (context?.responseHeaders) {
        // Server-side: append to the response headers.
        context.responseHeaders.append('Set-Cookie', cookieString);
    }
    else if (typeof document !== 'undefined') {
        // Client-side: set on document.cookie.
        document.cookie = cookieString;
    }
}
/**
 * Deletes a cookie by setting its expiration to a past date.
 * Works on both client and server.
 * @param name The name of the cookie.
 * @param options Serialization options (e.g., path, domain).
 * @param context The server context, containing the `responseHeaders` object for server-side operations.
 */
export function deleteCookie(name, options, context) {
    // Set the cookie with a maxAge of 0 to expire it immediately.
    setCookie(name, '', { ...options, maxAge: 0 }, context);
}
//# sourceMappingURL=cookies.js.map